<ng-container *ngIf="page">
    <tt-field-group>
        <tt-field-group>
            <tt-vat-report-submission-steps
                [steps]="submissionSteps"
                [stepNo]="page.submission_step_no"
            ></tt-vat-report-submission-steps>

            <tt-card ttHeading="h_info">
                <tt-field-group>
                    <tt-input
                        ttLabel="vatreport_keyno"
                        ttLabelView="top"
                        [ttModel]="page.vatreport_keyno"
                        ttReadonly
                    ></tt-input>

                    <tt-input
                        ttLabel="businessco_no"
                        ttLabelView="top"
                        [ttModel]="page.businessco_no"
                        ttReadonly
                    ></tt-input>

                    <tt-input
                        class="col-3"
                        ttLabel="businessco_companyname"
                        ttLabelView="top"
                        [ttModel]="page.businessco_companyname"
                        ttReadonly
                    ></tt-input>
                </tt-field-group>

                <tt-input
                    ttLabel="taxperiod_name"
                    ttLabelView="top"
                    [ttModel]="page.taxperiod_name"
                    ttReadonly
                ></tt-input>

                <tt-field-group>
                    <tt-input
                        ttLabel="reg_datetime"
                        ttLabelView="top"
                        [ttModel]="page.reg_datetime"
                        ttReadonly
                    ></tt-input>

                    <tt-input
                        ttLabel="reg_by_portal_user"
                        ttLabelView="top"
                        [ttModel]="page.reg_by_portal_user"
                        ttReadonly
                    ></tt-input>

                    <tt-input
                        ttLabel="last_updated_dt"
                        ttLabelView="top"
                        [ttModel]="page.last_updated_dt"
                        ttReadonly
                    ></tt-input>
                </tt-field-group>

                <tt-field-group>
                    <tt-input
                        *ngIf="+page.acvoucherbunt_keyno > 0"
                        ttLabel="acvoucherbunt_keyno"
                        ttLabelView="top"
                        [ttModel]="page.acvoucherbunt_keyno"
                        ttReadonly
                    >
                        <tt-form-field-button
                            buttons
                            ttIcon="fas fa-chevron-right"
                            ttGoto="acledger"
                            [ttGotoParms]="{ argtype: 'acvoucherbunt_keyno', argvalue: page.acvoucherbunt_keyno }"
                        ></tt-form-field-button>
                    </tt-input>

                    <tt-input
                        *ngIf="+page.acvoucherbunt_keyno_rollback > 0"
                        ttLabel="acvoucherbunt_keyno_rollback"
                        ttLabelView="top"
                        [ttModel]="page.acvoucherbunt_keyno_rollback"
                        ttReadonly
                    >
                        <tt-form-field-button
                            buttons
                            ttIcon="fas fa-chevron-right"
                            ttGoto="acledger"
                            [ttGotoParms]="{ argtype: 'acvoucherbunt_keyno', argvalue: page.acvoucherbunt_keyno_rollback }"
                        ></tt-form-field-button>
                    </tt-input>

                    <tt-input
                        *ngIf="+page.vatreport_keyno_replaced_by > 0"
                        ttLabel="vatreport_keyno_replaced_by"
                        ttLabelView="top"
                        [ttModel]="page.vatreport_keyno_replaced_by"
                        ttReadonly
                    >
                        <tt-form-field-button
                            buttons
                            ttIcon="fas fa-chevron-right"
                            ttGoto="vatreportmenu-test"
                            [ttGotoParms]="{ vatreport_keyno: page.vatreport_keyno_replaced_by }"
                        ></tt-form-field-button>
                    </tt-input>

                    <tt-input
                        *ngIf="+page.vatreport_keyno_replacment_for > 0"
                        ttLabel="vatreport_keyno_replacment_for"
                        ttLabelView="top"
                        [ttModel]="page.vatreport_keyno_replacment_for"
                        ttReadonly
                    >
                        <tt-form-field-button
                            buttons
                            ttIcon="fas fa-chevron-right"
                            ttGoto="vatreportmenu-test"
                            [ttGotoParms]="{ vatreport_keyno: page.vatreport_keyno_replacment_for }"
                        ></tt-form-field-button>
                    </tt-input>
                </tt-field-group>
            </tt-card>
        </tt-field-group>

        <tt-card ttHeading="attachment" ttTranslateHeading>
            <tt-file-uploader
                ttLabelView="none"
                ttLabel="attachment"
                ttLabelView="top"
                [ttFiles]="files"
                (ttFilesChange)="onFilesChanged($event)"
                [ttDisabled]="busy"
                ttMultiple
                ttDropZone
            ></tt-file-uploader>

            <ng-container *ngIf="receiptUrl">
                <span class="receipt-label" ttTranslateWord="feedback"></span>

                <a class="receipt-link" [href]="receiptUrl" download="kvittering.pdf">
                    <span class="fas fa-file-pdf"></span>
                    <span ttTranslateWord="download_receipt"></span>
                </a>
            </ng-container>
        </tt-card>
    </tt-field-group>

    <tt-card class="report-actions">
        <tt-field-group>
            <tt-button
                *ngIf="!(idporten.authenticated$ | async)"
                ttText="login_idporten"
                (ttClick)="login()"
                ttType="success"
                ttIcon="fas fa-sign-in-alt"
                [ttLoading]="action === 'login'"
                [ttDisabled]="busy"
            ></tt-button>

            <tt-button-multi
                *ngIf="page.is_sent === '0'"
                ttText="vatreportmenu_send"
                ttIcon="fas fa-paper-plane"
                (ttClick)="sendToAltinn(0)"
                [ttLoading]="action === 'send'"
                [ttDisabled]="busy || !(idporten.authenticated$ | async)"
                [ttTooltipText]="!(idporten.authenticated$ | async) ? signInTooltip : ''"
                ttTranslateTooltipText="false"
            >
                <tt-overflow-menu ttType="primary">
                    <tt-overflow-menu-item
                        ttText="vatreportmenu_validate"
                        ttIcon="far fa-check"
                        (ttClick)="validate()"
                        [ttDisabled]="busy || !(idporten.authenticated$ | async)"
                        [ttTooltipText]="!(idporten.authenticated$ | async) ? signInTooltip : ''"
                        ttTranslateTooltipText="false"
                    ></tt-overflow-menu-item>

                    <tt-overflow-menu-item
                        ttText="vatreportmenu_transfer"
                        ttIcon="far fa-paper-plane"
                        (ttClick)="sendToAltinn(1)"
                        [ttDisabled]="busy || !(idporten.authenticated$ | async)"
                    ></tt-overflow-menu-item>
                </tt-overflow-menu>
            </tt-button-multi>

            <tt-button
                *ngIf="page.is_sent === '0'"
                ttText="vatreportmenu_get_feedback"
                (ttClick)="retrieveFeedback()"
                ttIcon="far fa-comments"
                [ttLoading]="action === 'feedback'"
                [ttDisabled]="busy || !(idporten.authenticated$ | async) || +page.submission_step_no < 5"
            ></tt-button>

            <tt-button-multi
                *ngIf="page.is_accounted === '0' && page.is_sent === '0'"
                ttText="vatreportmenu_account"
                ttIcon="fas fa-sync"
                (ttClick)="accountReport()"
                [ttLoading]="action === 'account'"
                [ttDisabled]="busy"
            >
                <tt-overflow-menu>
                    <tt-overflow-menu-item
                        ttText="vatreportmenu_delete"
                        ttIcon="far fa-backspace"
                        ttDanger
                        ttHasDivider
                        (ttClick)="deleteReport()"
                        [ttDisabled]="busy"
                    ></tt-overflow-menu-item>
                </tt-overflow-menu>
            </tt-button-multi>

            <tt-button
                *ngIf="idporten.authenticated$ | async"
                ttText="logout_idporten"
                (ttClick)="logout()"
                ttType="ghost-danger"
                ttIcon="far fa-sign-out"
                [ttLoading]="action === 'logout'"
                [ttDisabled]="busy"
            ></tt-button>

            <tt-button
                *ngIf="page.is_accounted === '0'"
                ttText="vatreportmenu_update"
                (ttClick)="updateReport()"
                ttIcon="fas fa-sync-alt"
                [ttLoading]="action === 'update'"
                [ttDisabled]="busy"
            ></tt-button>
        </tt-field-group>
    </tt-card>

    <tt-grid *ngIf="grid" [ttOptions]="grid">
        <tt-overflow-menu toolbarButtons ttText="tt_grid_overflow_menu_tooltip">
            <tt-overflow-menu-item
                ttText="vatreportmenu_save_xml"
                (ttClick)="exportToXml()"
                ttIcon="fas fa-file-export"
                [ttDisabled]="busy"
            ></tt-overflow-menu-item>
        </tt-overflow-menu>
    </tt-grid>

    <a #exportAnchor hidden></a>
</ng-container>
